import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Flex, SkeletonText, Spinner } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useGetExcludeLocationsQuery } from 'store/facebookServices/facebookServicesApi';
import countries from 'i18n-iso-countries';
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

function ExcludeLocations({ adsAccountId, onRegionsUpdated }) {
  const { data: excludeLocations, isLoading, isFetching, refetch } = useGetExcludeLocationsQuery(
    { adsAccountId },
    { skip: !adsAccountId }
  );

  // Extract regions from excludeLocations
  const regions = excludeLocations?.[0]?.audience_controls?.excluded_geo_locations?.regions || [];
  const countryCode = regions?.[0]?.country;
  const countryName = countries.getName(countryCode, 'en', { select: 'official' });

  const hasExcludedLocations = excludeLocations && excludeLocations?.[0]?.audience_controls?.excluded_geo_locations;


   // When regions are updated
   useEffect(() => {
    if (regions.length > 0) {
      onRegionsUpdated(regions);
    }
  }, [regions]);

  return (
    <Box>
      {isLoading ? (
        <Flex>
            <Spinner size={'sm'}/>
        </Flex>
      ) : hasExcludedLocations ? (
        <Accordion allowToggle border="none" mx={-1}>
          <AccordionItem border="none">
            <AccordionButton _expanded={{ borderBottom: 'none' }}>
              <Box flex="1" textAlign="left">
                <Text fontWeight={'bold'}>Excluded locations</Text>
                <Text fontSize={'14px'}>
                  You have set location exclusions. These can't be changed for individual campaigns.
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel>
              {/* Displaying the regions in grey, side by side */}
              <Box>
                {regions.length > 0 ? (
                  <>
                    <Text color={'gray'} fontSize={'14px'} fontWeight={'bold'}>{countryName}</Text>
                    <Box display="flex" flexWrap="wrap" gap={1}>
                      {regions?.map((region) => (
                        <Box key={region?.key}>
                          <Text color={'gray'} fontSize={'12px'}>
                            {region?.name}{';'}
                          </Text>
                        </Box>
                      ))}
                    </Box>
                  </>
                ) : (
                  <Text>No regions excluded</Text>
                )}
              </Box>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      ) : (
        <Box>
            <Text fontWeight={'bold'}>Excluded locations</Text>
            <Text fontSize={'14px'}>No location exclusions are set for this ad account.</Text>
        </Box>
      )}
    </Box>
  );
}

export default ExcludeLocations;
